import cn from 'classnames'
import { memo, useCallback, useState } from 'react'

import { PartnerHierarchy } from 'clickNgo/containers/partnerHierarchy'
import { IPartner } from 'clickNgo/entities/partner/models'

import styles from './PartnerSelector.module.scss'

interface IProps {
  partnerId: string
  onPartnerSelect: (partner: IPartner) => void
  onPartnerSelectorToggle?: (isOpen: boolean) => void
}

export const PartnerSelector = memo<IProps>(
  ({ partnerId, onPartnerSelect, onPartnerSelectorToggle }) => {
    const [isPartnerSelectorVisible, setIsPartnerSelectorVisible] = useState(true)

    const stickerIcon = isPartnerSelectorVisible
      ? 'kbase kbase-omni-chevron-down'
      : 'kbase kbase-omni-chevron-up'

    const handleOnPartnerSelectorToggle = useCallback(() => {
      setIsPartnerSelectorVisible((prev) => {
        onPartnerSelectorToggle?.(!prev)
        return !prev
      })
    }, [onPartnerSelectorToggle])

    return (
      <div className={cn(styles.partners)}>
        <div
          className={cn(styles.partnerFormContent, { [styles.hidden]: !isPartnerSelectorVisible })}
        >
          <div className={cn(styles.partnerFormContentInner)}>
            <PartnerHierarchy partnerId={partnerId} onPartnerSelect={onPartnerSelect} />
          </div>
        </div>
        <div className={styles.partnerFormSticker} onClick={handleOnPartnerSelectorToggle}>
          <div className={styles.sticker}>
            Partner hierarchy{' '}
            <span>
              <i className={stickerIcon} />
            </span>
          </div>
        </div>
      </div>
    )
  }
)
